import { render, staticRenderFns } from "./tzproduct9.vue?vue&type=template&id=4c48db4d&scoped=true"
import script from "./tzproduct9.vue?vue&type=script&lang=js"
export * from "./tzproduct9.vue?vue&type=script&lang=js"
import style0 from "./tzproduct9.vue?vue&type=style&index=0&id=4c48db4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48db4d",
  null
  
)

export default component.exports